import { useRoutes, Navigate } from "react-router-dom";
//import CRM from "../Components/View/CRM/CRM";
import React, { Suspense, lazy } from "react";
import Home from "../Views/Home";
import Unauthorized from "./Unauthorized";
import AdminLayout from "../Views/Admin/AdminLayout";
import AdminMembersPage from "../Views/Admin/AdminMembersPage";
import BooksRentalList from "../Views/Admin/BooksRentalList";
import Payments from "../Views/Admin/Payments";
import HomePage from "../Views/Home/HomeTopSection";
import UsersPage from "../Views/Admin/UsersPage";
const SiteConfiguration = lazy(() => import("../Views/Admin/Site/SiteConfig"));
const LibReceipt = lazy(() => import("../Views/Admin/PrintContent"));
const AdminBooksPage = lazy(() => import("../Views/Admin/AdminBooksPage"));
const Catalog = lazy(() => import("../Views/Catalog"));
const AdminPage = lazy(() => import("../Views/Admin/LibraryDashboard"));
const Library_invoice = lazy(() => import("../Views/Admin/library_invoice"));
// Wrap the components with the withAuthorization HOC to protect the routes

const ProtectedRoute = ({ element, rights = [], allowedRights }) => {
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  console.log(userData);
  console.log(rights);
  console.log(allowedRights);
  if (!rights || rights.length === 0) {
    return <Unauthorized />; // or a spinner
  }
  if (!userData.token || userData.token === "undefined") {
    return <Navigate to="/unauthorized" replace />;
  }

  const hasPermission = allowedRights.some((right) => rights.includes(right));

  return hasPermission ? element : <Navigate to="/unauthorized" replace />;
};

export default function Routing({ userRights, setUserRights }) {
  let elements = useRoutes([
    {
      path: "/",
      element: <Home setUserRights={setUserRights} />,
    },
    {
      path: "unauthorized",
      element: <Unauthorized />,
    },
    {
      path: "home",
      element: <HomePage setUserRights={setUserRights} />, // new Kyts home
    },
    {
      path: "books",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <AdminBooksPage />
            </Suspense>
          }
          rights={userRights}
          allowedRights={[
            "Admin",
            "Accounts",
            "Manager",
            "Reception",
            "Subscriber",
          ]}
        />
      ),
    },
    {
      path: "catalog",
      element: (
        <ProtectedRoute
          element={
            <Suspense
              fallback={<div>Component1 is loading, please wait...</div>}
            >
              <Catalog />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Reception", "Accounts", "Manager"]}
        />
      ),
    },
    {
      path: "admin-dashboard",
      element: (
        <ProtectedRoute
          element={
            <Suspense
              fallback={<div>Component1 is loading, please wait...</div>}
            >
              <AdminPage />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Reception", "Accounts", "Manager"]}
        />
      ),
    },
    {
      path: "admin",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <AdminLayout />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
      children: [
        {
          path: "",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <AdminPage />
                </Suspense>
              }
              rights={userRights}
              allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
            />
          ),
        },
        {
          path: "dashboard",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <AdminPage />
                </Suspense>
              }
              rights={userRights}
              allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
            />
          ),
        },
        {
          path: "books", //  "/library_member",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <AdminBooksPage />
                </Suspense>
              }
              rights={userRights}
              allowedRights={[
                "Admin",
                "Accounts",
                "Manager",
                "Reception",
                "Subscriber",
              ]}
            />
          ),
        },
        {
          path: "members",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <AdminMembersPage />
                </Suspense>
              }
              rights={userRights}
              allowedRights={[
                "Admin",
                "Accounts",
                "Manager",
                "Reception",
                "Subscriber",
              ]}
            />
          ),
        },
         {
          path: "users",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <UsersPage />
                </Suspense>
              }
              rights={userRights}
              allowedRights={[
                "Admin",
                "Accounts",
                "Manager",
                "Reception",
                "Subscriber",
              ]}
            />
          ),
        },
        {
          path: "rentals",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <BooksRentalList />
                </Suspense>
              }
              rights={userRights}
              allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
            />
          ),
        },
        {
          path: "payments",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <Library_invoice />
                </Suspense>
              }
              rights={userRights}
              allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
            />
          ),
        },
        {
          path: "invoices",
          element: (
            <ProtectedRoute
              element={
                <Suspense fallback={<div>Component1 is loading...</div>}>
                  <Payments />
                </Suspense>
              }
              rights={userRights}
              allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
            />
          ),
        },
      ],
    },
    {
      path: "print",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <LibReceipt />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin", "Accounts", "Manager", "Reception"]}
        />
      ),
    },
     {
      path: "settings",
      element: (
        <ProtectedRoute
          element={
            <Suspense fallback={<div>Component1 is loading...</div>}>
              <SiteConfiguration />
            </Suspense>
          }
          rights={userRights}
          allowedRights={["Admin"]}
        />
      ),
    },
  ]);

  return elements;
}
